import React from 'react';
import { useUser } from '@repo/hooks/useUser';
import { useAccount } from '@/hooks/useAccount';
import { Link } from 'react-router';
import { Card } from '@repo/ui/Card';
import { QuickLinks } from '@repo/ui/QuickLinks';
import { QuickLinkType } from '@repo/ui/QuickLinks';

import { POLICIES } from '@/lib/Authorization';

const TcrQuickLinks = () => {
  const user = useUser();

  const account = useAccount();
  const accountId = account.id;

  const links: (QuickLinkType | null)[] = [
    POLICIES['csp_brands:index'](user)
      ? {
          title: 'TCR Brands',
          description: 'View your registered 10DLC brands.',
          icon: 'corporate_fare',
          href: `/a/${accountId}/tcr/brands`,
          as: Link,
        }
      : null,
    POLICIES['csp_campaigns:index'](user)
      ? {
          title: 'TCR Campaigns',
          description: 'View your registered 10DLC campaigns.',
          icon: 'campaign',
          href: `/a/${accountId}/tcr/campaigns`,
          as: Link,
        }
      : null,
  ];

  return (
    <Card title="Quicklinks">
      <QuickLinks links={links} />
    </Card>
  );
};

export default TcrQuickLinks;
